export const prefixBuilderAddedCssTagId = (styleTagId: string) =>
  `breakdance-builder-added-css__${styleTagId}`;
